module.exports = __webpack_public_path__ + "static/img/logo_MF.469cf9de.png";